module.exports = __webpack_public_path__ + "img/check.0ad2234c.svg";